import {
	addStore,
	deleteStore,
	getStores,
	getTinyStores,
	getTinyStoresWithOperator,
	getTinyStoresWithOperatorCsv,
	updateStore,
	updateStoresByCsv
} from '../helpers/storeService';
import {checkError, closeAlert, receiveErrorAlert} from './commonsActions';

/*
 * action types
 */

export const FETCH_STORES_BEGIN   = 'FETCH_STORES_BEGIN';
export const FETCH_STORES_SUCCESS = 'FETCH_STORES_SUCCESS';
export const GET_FILTERED_STORES = 'GET_FILTERED_STORES';

export const FETCH_TINY_STORES_BEGIN   = 'FETCH_TINY_STORES_BEGIN';
export const FETCH_TINY_STORES_SUCCESS = 'FETCH_TINY_STORES_SUCCESS';

export const FETCH_TINY_STORES_WITH_OPERATOR_BEGIN   = 'FETCH_TINY_STORES_WITH_OPERATOR_BEGIN';
export const FETCH_TINY_STORES_WITH_OPERATOR_SUCCESS = 'FETCH_TINY_STORES_WITH_OPERATOR_SUCCESS';

/*
 * action creators
 */

export const fetchStores = query => dispatch => {
	dispatch({
		type: FETCH_STORES_BEGIN
	});
	return getStores(query).then(res => {
		const stores = res;
		dispatch({
			type: FETCH_STORES_SUCCESS,
			payload: {
				stores: stores.data,
				numberOfElements : stores.numberOfElements,
				totalElements: stores.totalElements,
				totalPages: stores.totalPages
			}
		});
        // if (query && query.filter) {
        //     dispatch(filteringStores(query.filter));
        // } else {
        //     dispatch(filteringStores());
        // }
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const filteringStores = filter => (dispatch, getState) => {
    const state = getState();
    let filteredStores = state.storesReducer.stores;
    if (filter) {
        filter.forEach(item => {
            filteredStores = filteredStores.filter( store => {
                if (item.value && item.value !== '') {
                    if (store[item.name] == null) {
                        return false
                    }
                    return store[item.name].toLowerCase().indexOf(
                        item.value.toLowerCase()) !== -1;
                } else {
                    return true;
                }
            });
        })
    } else {
        filteredStores = state.storesReducer.stores;
    }
    dispatch({
        type: GET_FILTERED_STORES,
        stores: filteredStores
    });
};

export const saveNewStore = newStore => dispatch => {
	return addStore(newStore).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})

};

export const updateSingleStore = store => {
	return dispatch => {
		return updateStore(store).then(res => {
			return res;
		}, error => {
			dispatch(checkError(error));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
	};
};

export const deleteSingleStore = store => {
	return dispatch => {
		return deleteStore(store).then(res => {
			return res;
		}, error => {
			dispatch(checkError(error));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
	};
};

export const fetchTinyStores = query => dispatch => {
	dispatch({
		type: FETCH_TINY_STORES_BEGIN
	});
	return getTinyStores(query).then(res => {
		dispatch({
			type: FETCH_TINY_STORES_SUCCESS,
			payload: {
				tinyStores: res.data
			}
		});
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const fetchTinyStoresWithOperator = operatorCompanyId => dispatch => {
	dispatch({
		type: FETCH_TINY_STORES_WITH_OPERATOR_BEGIN
	});
	return getTinyStoresWithOperator(operatorCompanyId).then(res => {
		const stores = res;
		dispatch({
			type: FETCH_TINY_STORES_WITH_OPERATOR_SUCCESS,
			payload: {
				tinyStoresWithOperator: stores.data,
				numberOfElements : stores.numberOfElements,
				totalElements: stores.totalElements,
				totalPages: stores.totalPages
			}
		});
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const fetchTinyStoresWithOperatorCsv = query => dispatch => {
	return getTinyStoresWithOperatorCsv(query).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateStoresFromCsv = file => dispatch =>{
	const data = new FormData();
	data.append('file', file);
	return updateStoresByCsv(data).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};


// WEBPACK FOOTER //
// ./src/actions/storesActions.js